(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["boutique-comparatif-garnissages"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bnd-comparatif-g')) {
    customElements.define('bnd-comparatif-g', class extends HTMLElement {
      connectedCallback() {
        try { this.variantes = JSON.parse(this.querySelector('[data-bnd-variantes]')?.textContent || '{}'); } catch (e) { this.variantes = {}; }
        this.zone = this.closest('product-information, .product-information') || document;
        this.observateur = new MutationObserver(() => this.mettreAJour());
        this.observateur.observe(this.zone, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        this.zone.addEventListener('change', this.surChangement);
      }
      disconnectedCallback() { this.observateur?.disconnect(); this.zone?.removeEventListener('change', this.surChangement); }
      surChangement = () => requestAnimationFrame(() => this.mettreAJour());
      mettreAJour() {
        const champ = this.zone.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        const titre = this.variantes[champ?.value];
        if (titre === undefined) return;
        this.querySelectorAll('tr[data-bnd-cle]').forEach((tr) => {
          const actif = Boolean(tr.dataset.bndCle) && titre.includes(tr.dataset.bndCle);
          if (tr.classList.contains('bnd-comparatif-g__actif') !== actif) tr.classList.toggle('bnd-comparatif-g__actif', actif);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["boutique-complements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bnd-complements')) {
    customElements.define('bnd-complements', class extends HTMLElement {
      connectedCallback() {
        try { this.variantes = JSON.parse(this.querySelector('[data-bnd-variantes]')?.textContent || '{}'); } catch (e) { this.variantes = {}; }
        this.zone = this.closest('.product-information') || document.querySelector('.product-information') || document;
        this.filtrer();
        this.observateur = new MutationObserver(() => this.filtrer());
        this.observateur.observe(this.zone, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        this.zone.addEventListener('change', this.surChangement);
      }
      disconnectedCallback() { this.observateur?.disconnect(); this.zone?.removeEventListener('change', this.surChangement); }
      surChangement = () => requestAnimationFrame(() => this.filtrer());
      varianteChoisie() {
        const champ = this.zone.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') || this.zone.querySelector('input[name="id"]');
        const id = champ?.value || new URLSearchParams(location.search).get('variant');
        return this.variantes[id] || { titre: '', prix: 0 };
      }
      filtrer() {
        const variante = this.varianteChoisie();
        const titre = (variante.titre || '').toLowerCase().replace(/\s+/g, '');
        const plafond = Number(this.dataset.plafond || 0);
        let visibles = 0;
        this.querySelectorAll('.bnd-complement').forEach((li) => {
          const exclus = (li.dataset.exclus || '').split(',').map((s) => s.trim()).filter(Boolean);
          const tropCher = plafond > 0 && Number(variante.prix || 0) + Number(li.dataset.prix || 0) > plafond;
          const cache = tropCher || (Boolean(titre) && exclus.some((e) => titre.includes(e)));
          li.hidden = cache;
          if (!cache) visibles += 1;
        });
        this.hidden = visibles === 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["boutique-conseil"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bnd-conseil')) {
    customElements.define('bnd-conseil', class extends HTMLElement {
      connectedCallback() {
        this.zone = this.closest('.product-information, product-information, section') || document;
        this.appliquer();
        this.observateur = new MutationObserver(() => this.appliquer());
        this.observateur.observe(this.zone, { childList: true, subtree: true });
        if (this.dataset.preselection === 'true' && !window.bndPreselectionFaite && !new URLSearchParams(location.search).has('variant')) {
          window.bndPreselectionFaite = true;
          requestAnimationFrame(() => this.preselectionner());
        }
      }
      disconnectedCallback() { this.observateur?.disconnect(); }
      cle(texte) { return (texte || '').toLowerCase().replace(/\s+/g, ''); }
      nombre(texte) { const m = (texte || '').match(/\d+/); return m ? parseInt(m[0], 10) : NaN; }
      appliquer() {
        let cible = this.cle(this.dataset.valeur);
        // Arrivée par une adresse de variante (annonce « grand froid » sur le 1300 g, par exemple) : pas de badge sur une autre valeur,
        // pour ne pas contredire le choix du visiteur (repasse conversion du 20 oct.). Le tri et le reste du conseil restent.
        if (this.sansBadge === undefined && new URLSearchParams(location.search).has('variant')) {
          const coche = this.zone.querySelector('.bnd-garnissage input:checked, fieldset input:checked');
          if (coche) this.sansBadge = !this.cle(coche.value).includes(cible);
        }
        if (this.sansBadge) cible = '';
        this.zone.querySelectorAll('fieldset, .variant-option').forEach((groupe) => {
          const etiquettes = [...groupe.querySelectorAll(':scope > label.variant-option__button-label, label.variant-option__button-label')];
          if (!etiquettes.length) return;
          const nombres = etiquettes.map((l) => this.nombre(l.querySelector('input')?.value));
          const tousNumeriques = nombres.every((n) => !Number.isNaN(n));
          const garnissage = tousNumeriques && etiquettes.length > 2;
          groupe.classList.toggle('bnd-garnissage', garnissage);
          if (garnissage) groupe.style.setProperty('--bnd-nb', String(etiquettes.length));
          etiquettes.forEach((l, i) => {
            const valeur = this.cle(l.querySelector('input')?.value);
            if (this.dataset.trier === 'true' && tousNumeriques) l.style.order = String(nombres[i]);
            const recommande = cible && valeur.includes(cible);
            l.classList.toggle('bnd-recommande', recommande);
            if (recommande && this.dataset.badge) l.dataset.bndBadge = this.dataset.badge;
          });
        });
        this.zone.querySelectorAll('variant-picker select option').forEach((o) => {
          if (cible && this.cle(o.value).includes(cible) && this.dataset.badge && !o.textContent.includes(this.dataset.badge)) {
            o.textContent = `${o.textContent} (${this.dataset.badge})`;
          }
        });
      }
      preselectionner() {
        const cible = this.cle(this.dataset.valeur);
        if (!cible) return;
        const entree = [...this.zone.querySelectorAll('label.variant-option__button-label input')].find((i) => this.cle(i.value).includes(cible));
        if (entree && !entree.checked) entree.click();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["boutique-date-livraison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bnd-date-livraison')) {
    customElements.define('bnd-date-livraison', class extends HTMLElement {
      connectedCallback() {
        const feries = new Set((this.dataset.feries || '').split(',').filter(Boolean));
        const ouvre = (d) => {
          const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
          return d.getDay() !== 0 && d.getDay() !== 6 && !feries.has(iso);
        };
        const ajouter = (jours) => {
          const d = new Date();
          d.setHours(12, 0, 0, 0);
          let n = 0;
          while (n < jours) { d.setDate(d.getDate() + 1); if (ouvre(d)) n += 1; }
          return d;
        };
        const min = Number(this.dataset.min || 5);
        const max = Number(this.dataset.max || 10);
        if (this.dataset.style === 'frise') {
          const jour = new Intl.DateTimeFormat('fr-FR', { day: 'numeric' });
          const jourMois = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
          const plage = (a, b) => a.getMonth() === b.getMonth() ? `${jour.format(a)} au ${jourMois.format(b)}` : `${jourMois.format(a)} au ${jourMois.format(b)}`;
          const dates = [jourMois.format(ajouter(0)), plage(ajouter(Number(this.dataset.prepMin || 1)), ajouter(Number(this.dataset.prepMax || 3))), plage(ajouter(min), ajouter(max))];
          this.querySelectorAll('[data-bnd-etape]').forEach((el) => { el.textContent = dates[Number(el.dataset.bndEtape)]; });
          return;
        }
        const format = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
        const texte = this.querySelector('[data-bnd-texte]');
        if (texte) texte.innerHTML = `Livraison offerte et suivie, chez toi entre le <strong>${format.format(ajouter(min))}</strong> et le <strong>${format.format(ajouter(max))}</strong>`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["boutique-prix-3x"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bnd-prix-3x')) {
    customElements.define('bnd-prix-3x', class extends HTMLElement {
      connectedCallback() {
        try { this.prix = JSON.parse(this.querySelector('[data-bnd-prix]')?.textContent || '{}'); } catch (e) { this.prix = {}; }
        this.zone = this.closest('product-information, .product-information') || document;
        this.observateur = new MutationObserver(() => this.mettreAJour());
        this.observateur.observe(this.zone, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        this.zone.addEventListener('change', this.surChangement);
        this.mettreAJour();
      }
      disconnectedCallback() { this.observateur?.disconnect(); this.zone?.removeEventListener('change', this.surChangement); }
      surChangement = () => requestAnimationFrame(() => this.mettreAJour());
      format(centimes) { return `${(centimes / 100).toFixed(2).replace('.', ',').replace(',00', '')} €`; }
      mettreAJour() {
        const champ = this.zone.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        const prix = this.prix[champ?.value];
        if (prix === undefined) return;
        const cache = prix < Number(this.dataset.seuil || 0);
        if (this.hidden !== cache) this.hidden = cache;
        const texte = (this.dataset.modele || '').replace('[montant]', this.format(Math.round(prix / 3)));
        const cible = this.querySelector('[data-bnd-texte]');
        if (cible && cible.textContent !== texte) cible.textContent = texte;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["boutique-prix-nuit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bnd-prix-nuit')) {
    customElements.define('bnd-prix-nuit', class extends HTMLElement {
      connectedCallback() {
        try { this.prix = JSON.parse(this.querySelector('[data-bnd-prix]')?.textContent || '{}'); } catch (e) { this.prix = {}; }
        this.zone = this.closest('product-information, .product-information') || document;
        this.observateur = new MutationObserver(() => this.mettreAJour());
        this.observateur.observe(this.zone, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        this.zone.addEventListener('change', this.surChangement);
        this.mettreAJour();
      }
      disconnectedCallback() { this.observateur?.disconnect(); this.zone?.removeEventListener('change', this.surChangement); }
      surChangement = () => requestAnimationFrame(() => this.mettreAJour());
      format(centimes) { return `${(centimes / 100).toFixed(2).replace('.', ',').replace(',00', '')} €`; }
      mettreAJour() {
        const champ = this.zone.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        const prix = this.prix[champ?.value];
        if (prix === undefined) return;
        const cache = prix < Number(this.dataset.seuil || 0);
        if (this.hidden !== cache) this.hidden = cache;
        const nuits = Number(this.dataset.nuits || 100);
        const texte = (this.dataset.modele || '').replace('[montant]', this.format(Math.round(prix / nuits))).replace('[nuits]', String(nuits));
        const cible = this.querySelector('[data-bnd-texte]');
        if (cible && cible.textContent !== texte) cible.textContent = texte;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["boutique-titre"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bnd-titre')) {
    customElements.define('bnd-titre', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.variable !== 'true') return;
        try { this.suffixes = JSON.parse(this.querySelector('[data-bnd-suffixes]')?.textContent || '{}'); } catch (e) { this.suffixes = {}; }
        this.zone = this.closest('product-information, .product-information') || document;
        this.titreOnglet = document.title;
        this.mettreAJour();
        this.observateur = new MutationObserver(() => this.mettreAJour());
        this.observateur.observe(this.zone, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        this.zone.addEventListener('change', this.surChangement);
      }
      disconnectedCallback() { this.observateur?.disconnect(); this.zone?.removeEventListener('change', this.surChangement); }
      surChangement = () => requestAnimationFrame(() => this.mettreAJour());
      mettreAJour() {
        const champ = this.zone.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        const id = champ?.value || new URLSearchParams(location.search).get('variant');
        const suffixe = (id && this.suffixes[id]) || '';
        const base = this.querySelector('[data-bnd-base]');
        const fin = this.querySelector('[data-bnd-suffixe]');
        if (!base || !fin) return;
        const texteBase = suffixe ? this.dataset.base : this.dataset.titre;
        const texteFin = suffixe ? ` · ${suffixe}` : '';
        if (base.textContent !== texteBase) base.textContent = texteBase;
        if (fin.textContent !== texteFin) fin.textContent = texteFin;
        const complet = texteBase + texteFin;
        if (this.titreOnglet.startsWith(`${this.dataset.titre} ·`)) {
          const onglet = this.titreOnglet.replace(this.dataset.titre, complet);
          if (document.title !== onglet) document.title = onglet;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
